'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _ramda = require('ramda');
var _reactRedux = require('react-redux');
var _reduxForm = require('redux-form');
var _reduxConnect = require('redux-connect');
var _reduxPagan = require('redux-pagan');
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _reactRouter = require('react-router');
require('react-id-swiper/src/styles/css/swiper.css');
require('react-select/dist/react-select.css');
require('normalize.css/normalize.css');
require('../../theme/globals.css');


var _containers = require('../../containers');





var _components = require('../../components');







var _leads = require('../../redux/modules/leads');
var _propertiesAnalytics = require('../../redux/modules/propertiesAnalytics');
var _propertyDetails = require('../../redux/modules/propertyDetails');
var _messageModal = require('../../redux/modules/messageModal');
var _manageProperties = require('../../redux/modules/manageProperties');




var _mobilesFilters = require('../../redux/modules/mobilesFilters');
var _mobileHeader = require('../../redux/modules/mobileHeader');
var _windowDimentions = require('../../redux/modules/windowDimentions');
var _userAuthentication = require('../../redux/modules/userAuthentication');

















var _buyMoreQuestions = require('../../redux/modules/buyMoreQuestions');



var _favoriteProperties = require('../../redux/modules/favoriteProperties');





var _propertyNotes = require('../../redux/modules/propertyNotes');
var _myAccount = require('../../redux/modules/myAccount');
var _native = require('../../redux/modules/native');
var _propertyTypes = require('../../redux/modules/propertyTypes');
var _saveSearchLocation = require('../../redux/modules/saveSearchLocation');


var _config = require('../../config');var _config2 = _interopRequireDefault(_config);
var _WindowDimentionManager = require('../../helpers/WindowDimentionManager');var _WindowDimentionManager2 = _interopRequireDefault(_WindowDimentionManager);
var _constants = require('../../constants');










var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _localization = require('../../helpers/localization');
var _sentry = require('../../helpers/sentry');
var _routerAdapter = require('../../helpers/routerAdapter');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _setupStorage = require('../../utils/setupStorage');var _setupStorage2 = _interopRequireDefault(_setupStorage);
var _checkRtlLanguage = require('../../utils/checkRtlLanguage');var _checkRtlLanguage2 = _interopRequireDefault(_checkRtlLanguage);
var _checkers = require('../../utils/checkers');
var _checkUserIsAllowedToPublish = require('../../utils/checkUserIsAllowedToPublish');
var _facebookSDK = require('../../utils/facebookSDK');


var _App = require('./App.scss');var styles = _interopRequireWildcard(_App);
var _checkUserAgent = require('../../utils/checkUserAgent');var _checkUserAgent2 = _interopRequireDefault(_checkUserAgent);
var _ConsultationForm = require('../../components/Company/ConsultationForm/ConsultationForm');var _ConsultationForm2 = _interopRequireDefault(_ConsultationForm);
var _scriptLoaders = require('../../helpers/scriptLoaders');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// helpers
// Styles
var App = function (_Component) {_inherits(App, _Component);function App() {var _temp, _this, _ret;_classCallCheck(this, App);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { sectionNames: (0, _constants.getSectionsNames)(), optionTypes: (0, _constants.getOptionTypes)(),
      publishDraftSaved: false }, _this.





































































































































































    getPagination = function (name) {
      if (typeof localStorage !== 'undefined') {
        try {
          var selectedPages = JSON.parse(localStorage.getItem(name));
          return selectedPages.value;
        } catch (e) {
          console.error('Failed to read ' + name + ' from localStorage');
          return 10;
        }
      }
      return 10;
    }, _this.

    checkIfCanSavePublishDraft = function () {
      var section = (0, _get2.default)(_this.props, 'publishFormValues.section');
      var route = (0, _get2.default)(_this.props, 'router.location.pathname', '');
      var isEditPage = route.includes('property/edit') ||
      route.includes('foreign_property/edit') ||
      route.includes('project/edit');

      return !isEditPage && !!section;
    }, _this.

    savePublishDraftToStorage = function (field) {
      var section = (0, _get2.default)(_this.props, 'publishFormValues.section');
      var isProjects = section === 'projects';
      var formValues = isProjects ? Object.assign({
        section: 'projects' },
      _this.props.publishProjectFormValues) :
      _this.props.publishFormValues;

      try {
        _constants.storage.value.setItem(field, JSON.stringify(formValues));
        _this.setState({ publishDraftSaved: true });

        setTimeout(function () {
          _this.setState({ publishDraftSaved: false });
        }, 1500);
      } catch (err) {
        console.error(err);
      }
    }, _this.

    publishClicked = function (event) {var _this$props =
      _this.props,isMobile = _this$props.isMobile,userAuthentication = _this$props.userAuthentication,manageProperties = _this$props.manageProperties;

      if (isMobile) {
        _this.props.hideMobileHeader();
      }

      var userData = (0, _get2.default)(userAuthentication, 'data', {});
      var propertiesData = (0, _get2.default)(manageProperties, 'data.meta.user_properties') || {};

      var userCanPublish = (0, _checkUserIsAllowedToPublish.isUserAllowedToPublishPage)(userData, propertiesData);

      if (userCanPublish) {
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.publish, _analyticsConstants.eventAction.open, _analyticsConstants.eventLabel.publish);
        return true;
      }

      // User can't publish now -> prevent route change, display modal
      event.preventDefault();
      var supportEmail = (0, _constants.getSupportEmail)();

      var cantPublishModal =
      _react2.default.createElement('div', { className: 'contentMessage' },
        _react2.default.createElement('p', null, _this.props.translate('publishProperty', 'doesNotAllowToPublishProperty'), ',', _react2.default.createElement('br', null),
          _this.props.translate('publishProperty', 'contactTo'),
          _react2.default.createElement('a', { href: 'mailto:' + supportEmail, className: 'link' }, ' ' + supportEmail)));




      _this.props.openMessageModal({ message: cantPublishModal });

      return false;
    }, _this.

    routeChanged = function (route) {
      _this.clearSavedPolygon(route);
      _this.hideAllModals();
    }, _this.

    clearSavedPolygon = function () {var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var isDetailsPage = route.includes('home_details') || route.includes('project_details');
      var isSearchPage = route.includes('homes') || route.includes('commercial') || route.includes('projects');
      var shouldClearPolygon = _constants.storage.value.getItem('polygonCoordinates') && !isDetailsPage && !isSearchPage;

      if (shouldClearPolygon) {
        _constants.storage.value.removeItem('polygonCoordinates');
      }
    }, _this.

    hideAllModals = function () {
      if (_this.props.userAuthentication.isAuthenticationModalOpen) {
        _this.props.hideAuthenticationModal();
      }
      if (_this.props.propertyDetails.isDetailsModalOpen) {
        _this.props.hideDetailsPopup();
      }
      if (_this.props.messageModal.isMessageModalOpen) {
        _this.props.hideMessageModal();
      }
      if (_this.props.mobilesFilters.isMobileFiltersOpen) {
        _this.props.hideMobileFilters();
      }
      if (_this.props.isBuyMoreQuestionsModalOpen) {
        _this.props.hideBuyMoreQuestionsModal();
      }
    }, _this.

    logOut = function () {
      _constants.storage.value.clear();
      _this.props.clearUserPropertiesData();
      _this.props.clearFavorites();
      _this.props.clearStoreNotes();
      _this.props.logOut();
      (0, _analyticsManager.setData)({ userId: null });
      (0, _analyticsManager.setData)({ dimension1: null });
    }, _this.

    handleHideAuthenticationModal = function () {
      if (_this.props.userAuthentication.selectedTab === _constants.userAuthenticationTabs.NEW_ACCOUNT) {
        // analytics
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.newAccount, _analyticsConstants.eventAction.close);
      }
      if (_this.props.userAuthentication.selectedTab === _constants.userAuthenticationTabs.SIGN_IN) {
        // analytics
        var userAuthorised = !!_this.props.userAuthentication.data;
        if (userAuthorised) {
          (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.login, _analyticsConstants.eventAction.success);
        } else {
          (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.login, _analyticsConstants.eventAction.close);
        }
      }
      _this.props.hideAuthenticationModal();
      return undefined;
    }, _this.

    renderChildren = function (children, childProps) {return _react2.default.Children.map(
      children,
      function (child) {return _react2.default.cloneElement(child, childProps);});}, _temp), _possibleConstructorReturn(_this, _ret);}App.prototype.componentWillMount = function componentWillMount() {if (!this.props.propertyTypes.data && !this.props.propertyTypes.loading) {this.props.receivePropertyTypes();}(0, _setupStorage2.default)();if (this.props.location.query && !!this.props.location.query.native) {this.props.setNative(true);}};App.prototype.componentDidMount = function componentDidMount() {var _this2 = this;(0, _facebookSDK.initFBSDK)(this.props.locale);(0, _scriptLoaders.googleAuthSDKLoader)(this.props.locale);if (this.props.userAuthentication.data && (0, _checkers.isTemporaryEmail)(this.props.userAuthentication.data.email)) {this.logOut();}var referralId = (0, _get2.default)(this.props, 'router.location.query.referral');if (referralId) {this.props.sendReferralId({ userId: referralId, action: 'referral' });_reactRouter.browserHistory.replace((0, _appendLocale2.default)(this.props.locale, '/'));}var _props = this.props,userAuthentication = _props.userAuthentication,leads = _props.leads;if (userAuthentication.userIsAuthorized && !leads.quantityLoading) {this.props.setQuantityLoading();this.props.loadDensityUnreadLeads({ token: this.props.userToken });}var isIE = _checkUserAgent2.default.isInternetExplorer((0, _get2.default)(navigator, 'userAgent', ''));var body = document.querySelector('body');var html = document.querySelector('html');body.classList.add(this.props.locale);if (isIE) {html.classList.add('ie-browser');}if (this.props.location.query.token) {this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.RESET_PASSWORD });}try {var data = this.props.userAuthentication.data;if (_constants.storage.value.getItem('polygonCoordinates')) {_constants.storage.value.removeItem('polygonCoordinates');}if (data) {(0, _analyticsManager.setData)({ userId: data.id });(0, _analyticsManager.setData)({ dimension1: data.is_agent ? 'realtor' : 'regular' });this.props.loadUserProperties({ token: data.access_token, data: { $limit: this.getPagination('rows-on-page'), $skip: 0, is_active: data.is_agent || undefined } });this.props.addSavedFavoritesToStore({ data: data.properties.favorites, token: data.access_token });this.props.addSavedNotesToStore({ notesData: data.properties.notes, token: data.access_token });if (!this.props.isMobile) {this.props.loadSavedSearchData({ token: data.access_token });}} else {this.props.addSavedFavoritesToStore({});this.props.addSavedNotesToStore({});}} catch (err) {console.error(err.message);}_reactRouter.browserHistory.listen(function (event) {var action = event.action;var propertyId = (0, _get2.default)(event, 'state.searchResultParams.propertyId');if (action === 'PUSH' && _this2.props.isMobile && _this2.scrollableContainer) {if (propertyId) {return;}_this2.scrollableContainer.scrollTop = 0;} else if (action === 'POP' && propertyId) {setTimeout(function () {return _this2.props.openDetailsPopup({ propertyId: propertyId });}, 0);}});window.addEventListener('beforeunload', function () {var userNotAuthorised = !_this2.props.userAuthentication.data;if (userNotAuthorised) {_this2.props.saveFavoritesData();}});this.props.initializeWindowDimensions();};App.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var html = document.querySelector('body');if (newProps.isDetailsModalOpen || newProps.isBuyMoreQuestionsModalOpen || newProps.isContactFormModalOpen) {html.classList.add('modalOpen');} else {html.classList.remove('modalOpen');}var userIsAuthorized = newProps.userAuthentication.userIsAuthorized;if (userIsAuthorized !== this.props.userAuthentication.userIsAuthorized) {var userData = newProps.userAuthentication.data;var neededUserData = userData ? (0, _pick2.default)(userData, ['id', 'display_name', 'email']) : null;(0, _sentry.setUserData)(neededUserData);}var data = newProps.userAuthentication.data;if (userIsAuthorized && userIsAuthorized !== this.props.userAuthentication.userIsAuthorized) {try {this.props.loadUserProperties({ token: data.access_token, data: { $limit: this.getPagination('rows-on-page'), $skip: 0, is_active: data.is_agent || undefined } });if (!this.props.isMobile) {this.props.loadSavedSearchData({ token: data.access_token });}this.props.loadDensityUnreadLeads({ token: data.access_token });this.props.addSavedFavoritesToStore({ data: data.properties.favorites, token: data.access_token });this.props.addSavedNotesToStore({ notesData: data.properties.notes, token: data.access_token });} catch (err) {console.error(err.message);}}if (userIsAuthorized && newProps.favoritesIDs && !(0, _isEqual2.default)(newProps.favoritesIDs, this.props.favoritesIDs)) {this.props.updateUserFavorites(newProps.favoritesIDs);}if (newProps.route && newProps.route !== this.props.route) {this.routeChanged(newProps.route);if (newProps.routeData.location === 'manage_properties' && (this.props.routeData.location === 'publish' || this.props.routeData.location === 'foreign_publish') && newProps.publishedProperty) {this.props.loadUserProperties({ token: data.access_token, data: { $limit: this.getPagination('rows-on-page'), $skip: 0, is_active: data.is_agent || undefined } });}}if (this.props.locale !== newProps.locale) {(0, _scriptLoaders.googleAuthSDKLoader)(newProps.locale);var _document$querySelect = document.querySelector('body'),classList = _document$querySelect.classList;classList.add(newProps.locale);classList.remove(this.props.locale);}};App.prototype.


  render = function render() {var _cx,_this3 = this;
    // Refactor this parts of code
    var _props2 = this.props,isMobile = _props2.isMobile,locale = _props2.locale,route = _props2.route,routeData = _props2.routeData,translate = _props2.translate,userAuthentication = _props2.userAuthentication,isRtl = _props2.isRtl,isNative = _props2.isNative;
    var location = this.props.routeData ? this.props.routeData.location : null;
    var optionType = this.props.routeData ? this.props.routeData.optionType : null;
    var sharedProp = {
      isMobile: isMobile,
      locale: locale,
      route: route,
      routeData: routeData,
      publishClicked: this.publishClicked,
      isRtl: isRtl,
      translate: translate,
      isNative: isNative,
      logOut: this.logOut };var

    isAuthenticationModalOpen = userAuthentication.isAuthenticationModalOpen,selectedTab = userAuthentication.selectedTab;var
    isMobileFiltersOpen = this.props.mobilesFilters.isMobileFiltersOpen;
    var hasGrayBg = location === 'home_details' || location === 'project_details';
    var isSearchResultPage = this.state.sectionNames.includes(location) &&
    this.state.optionTypes.includes(optionType) || location === 'projects';
    var isFailPaymentPage = location === 'payment-error';
    var isPageWithoutHeaderAndFooter = ['property_details'].indexOf('' + location) !== -1 || isFailPaymentPage;
    var userData = (0, _get2.default)(this.props, 'userAuthentication.data', {});
    var userHasProperties = (0, _get2.default)(this.props.userAuthentication, 'userIsAuthorized') && (

    (0, _get2.default)(this.props.userAuthentication, 'data.properties.total') > 0 ||
    (0, _get2.default)(this.props.userAuthentication, 'data.foreignProperties.total') > 0 ||
    (0, _get2.default)(this.props.manageProperties, 'data.meta.user_properties.total') > 0 ||
    (0, _get2.default)(this.props.manageProperties, 'data.meta.user_foreign_properties.total') > 0 ||
    !!(!isMobile && userData && userData.is_agent && userData.properties.allowed_until));

    var userHasCompany = !!(0, _get2.default)(this.props, 'userAuthentication.data');

    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)('main-wrapper', styles.app, (_cx = {}, _cx[
          styles.noOverflow] = isMobileFiltersOpen, _cx.
          mobile = isMobile, _cx.
          native = isNative, _cx.
          rtl = isRtl, _cx[
          styles.homePage] = !location, _cx[
          styles.gray] = hasGrayBg, _cx)),

          ref: function ref(scrollableContainer) {_this3.scrollableContainer = scrollableContainer;} },

        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(_components.AppHelmet, { translate: this.props.translate, locale: locale }),
        _react2.default.createElement(_WindowDimentionManager2.default, { onDimentionsChange: function onDimentionsChange(params) {return _this3.props.setWindowDimentions(params);} }),


        !isFailPaymentPage &&
        _react2.default.createElement(_components.AppHeader, _extends({},
        sharedProp, { // remove in the future
          isMobile: isMobile,
          switchAuthModalType: this.props.switchAuthModalType,
          translate: translate,
          locale: locale,
          location: routeData && routeData.location || '',
          route: route,
          userAuthentication: this.props.userAuthentication,
          openAuthenticationModal: this.props.openAuthenticationModal,
          openMessageModal: this.props.openMessageModal,
          logOut: this.logOut,
          publishClicked: this.publishClicked,
          isMobileFiltersOpen: this.props.mobilesFilters.isMobileFiltersOpen,
          isMobileMenuOpen: this.props.isMobileMenuOpen,
          openMobileFilters: this.props.openMobileFilters,
          hideMobileFilters: this.props.hideMobileFilters,
          openMobileHeader: this.props.openMobileHeader,
          hideMobileHeader: this.props.hideMobileHeader,
          isDetailsModalOpen: this.props.propertyDetails.isDetailsModalOpen,
          isPreview: this.props.propertyDetails.isPreview,
          hideDetailsPopup: this.props.hideDetailsPopup,
          setFavoritesListState: this.props.setFavoritesListState,
          isNative: isNative,
          pushRoute: this.props.router.push,
          isRtl: isRtl,
          propertyDetails: this.props.propertyDetails,
          userHasProperties: userHasProperties,
          userHasCompany: userHasCompany,
          numberLeads: this.props.leads.numberUnreadLeads,
          switchAccountView: this.props.switchAccountView,
          setPaginationStepForAgentManage: this.props.setPaginationStepForAgentManage,
          favoritesCount: (0, _get2.default)(this.props, 'favoritesIDs.length', 0),
          savedSearchesCount: this.props.savedSearchesCount,
          favoritesListIsActive: this.props.favoritesListIsActive,
          canSavePublishDraft: this.checkIfCanSavePublishDraft(),
          savePublishDraft: this.savePublishDraftToStorage,
          publishDraftSaved: this.state.publishDraftSaved })),






        this.renderChildren(this.props.children, sharedProp),

        _react2.default.createElement(_components.Footer, _extends({},
        sharedProp, { // remove in the future
          displaySocial: true,
          locale: locale,
          translate: translate,
          publishClicked: this.publishClicked,
          isFooterShown: !isMobileFiltersOpen && !isSearchResultPage && !isPageWithoutHeaderAndFooter,
          isMobile: isMobile,
          routeData: routeData,
          isNative: isNative,
          isRtl: isRtl })),



        _react2.default.createElement(_containers.PropertyDetailsModal, _extends({},
        sharedProp, { // remove in the future
          locale: locale,
          userData: userData,
          translate: translate,
          propertyDetails: this.props.propertyDetails,
          onRequestClose: this.props.hideDetailsPopup,
          isMobile: isMobile,
          routeData: this.props.routeData,
          publishClicked: this.publishClicked,
          isNative: isNative })),


        isAuthenticationModalOpen &&
        _react2.default.createElement(_containers.UserAuthentication, _extends({},
        sharedProp, { // remove in the future
          translate: translate,
          userAuthentication: this.props.userAuthentication,
          isOpen: true,
          selectedTab: selectedTab || _constants.userAuthenticationTabs.SIGN_IN,
          token: this.props.location.query.token,
          verifyToken: this.props.verifyToken,
          updatePassword: this.props.updatePassword,
          changePassword: this.props.changePassword,
          onRequestClose: this.handleHideAuthenticationModal,
          authenticateUser: this.props.authenticateUser,
          checkPhone: this.props.checkPhone,
          authenticateUserByNumber: this.props.authenticateUserByNumber,
          socialNetworkAuthentication: this.props.socialNetworkAuthentication,
          sendEmail: this.props.sendEmail,
          openAuthenticationModal: this.props.openAuthenticationModal,
          switchAuthModalType: this.props.switchAuthModalType,
          isMobile: isMobile,
          locale: locale,
          openMessageModal: this.props.openMessageModal,
          hideMessageModal: this.props.hideMessageModal,
          isMessageModalOpen: this.props.messageModal.isMessageModalOpen,
          logOut: this.logOut,
          editUserProfile: this.props.editUserProfile,
          clearUserAuthentication: this.props.clearUserAuthentication })),



        _react2.default.createElement(_components.Modal, _extends({},
          sharedProp, { // remove in the future
            className: this.props.messageModal.className || 'messageModal',
            locale: this.props.locale,
            isOpen: this.props.messageModal.isMessageModalOpen,
            onRequestClose: this.props.hideMessageModal,
            isCloseButtonInvisible: this.props.messageModal.isCloseButtonInvisible,
            translate: translate,
            messageModalClassName: this.props.messageModal.className,
            shouldCloseOnOverlayClick: this.props.messageModal.shouldCloseOnOverlayClick }),

          _react2.default.createElement('div', null, this.props.messageModal.message)),


        _react2.default.createElement(_containers.ContactUsModal, null),

        isMobile &&
        _react2.default.createElement(_components.Modal, {
            isOpen: isMobileFiltersOpen,
            onRequestClose: this.props.hideMobileFilters,
            className: 'mobileFilters',
            style: Object.assign({}, _constants.cleanModalStyle, {

              overlay: Object.assign({}, _constants.cleanModalStyle.overlay, { background: '#fff' }) }),

            plain: true,
            isRtl: this.props.isRtl },

          _react2.default.createElement(_containers.MobileFilterContainer, _extends({},
          sharedProp, { // remove in the future
            isRtl: isRtl })))));





  };return App;}(_react.Component);


App.propTypes = {
  receivePropertyTypes: _propTypes2.default.func,
  propertyTypes: _propTypes2.default.object,
  propertyDetails: _propTypes2.default.object,
  hideDetailsPopup: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  location: _propTypes2.default.object.isRequired,
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  userAuthentication: _propTypes2.default.object,
  authenticateUser: _propTypes2.default.func,
  checkPhone: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  hideAuthenticationModal: _propTypes2.default.func,
  isBuyMoreQuestionsModalOpen: _propTypes2.default.bool,
  openBuyMoreQuestionsModal: _propTypes2.default.func,
  hideBuyMoreQuestionsModal: _propTypes2.default.func,
  verifyToken: _propTypes2.default.func,
  updatePassword: _propTypes2.default.func,
  changePassword: _propTypes2.default.func,
  sendEmail: _propTypes2.default.func,
  logOut: _propTypes2.default.func,
  messageModal: _propTypes2.default.object,
  openMessageModal: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  clearUserPropertiesData: _propTypes2.default.func,
  route: _propTypes2.default.any,
  routeData: _propTypes2.default.object,
  switchAuthModalType: _propTypes2.default.func,
  mobilesFilters: _propTypes2.default.object,
  setWindowDimentions: _propTypes2.default.func,
  initializeWindowDimensions: _propTypes2.default.func,
  children: _propTypes2.default.object.isRequired,
  openMobileFilters: _propTypes2.default.func,
  hideMobileFilters: _propTypes2.default.func,
  openMobileHeader: _propTypes2.default.func,
  hideMobileHeader: _propTypes2.default.func,
  saveFavoritesData: _propTypes2.default.func,
  addSavedFavoritesToStore: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  isMobileMenuOpen: _propTypes2.default.bool,
  isDetailsModalOpen: _propTypes2.default.bool,
  router: _propTypes2.default.object,
  isRtl: _propTypes2.default.bool,
  favoritesIDs: _propTypes2.default.array,
  publishFormValues: _propTypes2.default.object,
  publishProjectFormValues: _propTypes2.default.object,
  updateUserFavorites: _propTypes2.default.func,
  addSavedNotesToStore: _propTypes2.default.func,
  setNative: _propTypes2.default.func,
  isNative: _propTypes2.default.bool,
  clearFavorites: _propTypes2.default.func,
  clearStoreNotes: _propTypes2.default.func,
  manageProperties: _propTypes2.default.object,
  loadUserProperties: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  openDetailsPopup: _propTypes2.default.func,
  setPaginationStepForAgentManage: _propTypes2.default.func,
  switchAccountView: _propTypes2.default.func,
  savedSearchesCount: _propTypes2.default.number,
  loadSavedSearchData: _propTypes2.default.func,
  favoritesListIsActive: _propTypes2.default.bool,
  userToken: _propTypes2.default.string,
  loadDensityUnreadLeads: _propTypes2.default.func,
  setQuantityLoading: _propTypes2.default.func,
  leads: _propTypes2.default.object,
  isContactFormModalOpen: _propTypes2.default.bool,
  clearUserAuthentication: _propTypes2.default.func,
  sendReferralId: _propTypes2.default.func };


var publishFormValuesSelector = (0, _reduxForm.formValueSelector)('PublishForm');
var projectFormValuesSelector = (0, _reduxForm.formValueSelector)('addNewProject');

var mapStateToProps = function mapStateToProps(_ref)

















{var propertyTypes = _ref.propertyTypes,propertyDetails = _ref.propertyDetails,userAuthentication = _ref.userAuthentication,messageModal = _ref.messageModal,lang = _ref.lang,routing = _ref.routing,mobilesFilters = _ref.mobilesFilters,favoriteProperties = _ref.favoriteProperties,saveSearchLocation = _ref.saveSearchLocation,buyMoreQuestions = _ref.buyMoreQuestions,isMobile = _ref.windowDimentions.isMobile,isMobileMenuOpen = _ref.mobileHeader.isMobileMenuOpen,manageProperties = _ref.manageProperties,publishProperty = _ref.publishProperty,native = _ref.native,contactFormModal = _ref.contactFormModal,state = _ref.state,leads = _ref.leads,rest = _objectWithoutProperties(_ref, ['propertyTypes', 'propertyDetails', 'userAuthentication', 'messageModal', 'lang', 'routing', 'mobilesFilters', 'favoriteProperties', 'saveSearchLocation', 'buyMoreQuestions', 'windowDimentions', 'mobileHeader', 'manageProperties', 'publishProperty', 'native', 'contactFormModal', 'state', 'leads']);
  var routeData = (0, _routerAdapter.extractRouteData)(routing, lang.locale);

  return {
    locale: routeData.locale,
    route: routeData.route,
    translate: (0, _reduxPagan.getLang)(lang, 'static'),
    routeData: routeData,
    propertyTypes: propertyTypes,
    propertyDetails: propertyDetails,
    userAuthentication: userAuthentication,
    messageModal: messageModal,
    mobilesFilters: mobilesFilters,
    isMobile: isMobile,
    isNative: native.isNative,
    isMobileMenuOpen: isMobileMenuOpen,
    isContactFormModalOpen: contactFormModal.isContactFormModalOpen,
    isBuyMoreQuestionsModalOpen: buyMoreQuestions.isBuyMoreQuestionsModalOpen,
    isDetailsModalOpen: propertyDetails.isDetailsModalOpen,
    isRtl: (0, _checkRtlLanguage2.default)(lang.locale),
    favoritesIDs: favoriteProperties.favoriteIDs,
    favoritesListIsActive: favoriteProperties.favoritesListIsActive,
    manageProperties: manageProperties,
    publishedProperty: publishProperty.published,
    userToken: (0, _get2.default)(userAuthentication, 'data.access_token'),
    leads: leads,
    savedSearchesCount: (0, _get2.default)(saveSearchLocation, 'data.length', 0),
    publishFormValues: publishFormValuesSelector.apply(undefined, [rest].concat(_constants.publishFormFieldsForSave)),
    publishProjectFormValues: projectFormValuesSelector.apply(undefined, [rest].concat(_constants.publishProjectFormFieldsForSave)) };

};

var mapDispatchToProps = {
  receivePropertyTypes: _propertyTypes.receivePropertyTypes,
  openDetailsPopup: _propertyDetails.openDetailsPopup,
  hideDetailsPopup: _propertyDetails.hideDetailsPopup,
  authenticateUser: _userAuthentication.authenticateUser,
  checkPhone: _userAuthentication.checkPhone,
  authenticateUserByNumber: _userAuthentication.authenticateUserByNumber,
  openAuthenticationModal: _userAuthentication.openAuthenticationModal,
  hideAuthenticationModal: _userAuthentication.hideAuthenticationModal,
  openBuyMoreQuestionsModal: _buyMoreQuestions.openBuyMoreQuestionsModal,
  hideBuyMoreQuestionsModal: _buyMoreQuestions.hideBuyMoreQuestionsModal,
  verifyToken: _userAuthentication.verifyToken,
  updatePassword: _userAuthentication.updatePassword,
  changePassword: _userAuthentication.changePassword,
  sendEmail: _userAuthentication.sendEmail,
  logOut: _userAuthentication.logOut,
  hideMessageModal: _messageModal.hideMessageModal,
  openMessageModal: _messageModal.openMessageModal,
  socialNetworkAuthentication: _userAuthentication.socialNetworkAuthentication,
  clearUserPropertiesData: _manageProperties.clearUserPropertiesData,
  hideMobileFilters: _mobilesFilters.hideMobileFilters,
  switchAuthModalType: _userAuthentication.switchAuthModalType,
  setWindowDimentions: _windowDimentions.setWindowDimentions,
  initializeWindowDimensions: _windowDimentions.initializeWindowDimensions,
  openMobileFilters: _mobilesFilters.openMobileFilters,
  openMobileHeader: _mobileHeader.openMobileHeader,
  hideMobileHeader: _mobileHeader.hideMobileHeader,
  saveFavoritesData: _favoriteProperties.saveFavoritesData,
  addSavedFavoritesToStore: _favoriteProperties.addSavedFavoritesToStore,
  setFavoritesListState: _favoriteProperties.setFavoritesListState,
  addSavedNotesToStore: _propertyNotes.addSavedNotesToStore,
  setNative: _native.setNative,
  updateUserFavorites: _userAuthentication.updateUserFavorites,
  clearFavorites: _favoriteProperties.clearFavorites,
  clearStoreNotes: _propertyNotes.clearStoreNotes,
  loadUserProperties: _manageProperties.loadUserProperties,
  editUserProfile: _userAuthentication.editUserProfile,
  switchAccountView: _myAccount.switchAccountView,
  setPaginationStepForAgentManage: _manageProperties.setCurrentPaginationStep,
  loadSavedSearchData: _saveSearchLocation.loadSavedSearchData,
  loadDensityUnreadLeads: _leads.loadDensityUnreadLeads,
  setQuantityLoading: _leads.setQuantityLoading,
  clearUserAuthentication: _userAuthentication.clearUserAuthentication,
  sendReferralId: _propertiesAnalytics.sendReferralId };


var asyncData = [{
  key: 'propertyTypes',
  promise: function promise(_ref2) {var _ref2$store = _ref2.store,dispatch = _ref2$store.dispatch,getState = _ref2$store.getState;
    var promises = [];var _getState =
    getState(),propertyTypes = _getState.propertyTypes;
    var noPropertyTypes = !propertyTypes.data || propertyTypes.data && !propertyTypes.data.length ||
    !propertyTypes.loaded && !propertyTypes.loading;

    if (noPropertyTypes) {
      promises.push(dispatch((0, _propertyTypes.receivePropertyTypes)()));
    }

    return Promise.all(promises);
  } },
{
  key: 'setupLocalization',
  promise: function promise(_ref3) {var locale = _ref3.params.locale,dispatch = _ref3.store.dispatch;return dispatch((0, _localization.setLocalization)(locale));} },
{
  key: 'userAuthentication',
  promise: function promise(_ref4) {var _ref4$store = _ref4.store,getState = _ref4$store.getState,dispatch = _ref4$store.dispatch;var _getState$userAuthent =
    getState().userAuthentication,accessToken = _getState$userAuthent.accessToken,data = _getState$userAuthent.data;
    if (accessToken && !data) {
      return dispatch((0, _userAuthentication.authUserByToken)(accessToken));
    }
    return null;
  } },
{
  key: 'userProperties',
  promise: function promise(_ref5) {var pathname = _ref5.location.pathname,_ref5$store = _ref5.store,getState = _ref5$store.getState,dispatch = _ref5$store.dispatch;var _getState$userAuthent2 =
    getState().userAuthentication,accessToken = _getState$userAuthent2.accessToken,rest = _objectWithoutProperties(_getState$userAuthent2, ['accessToken']);
    var isAgent = (0, _get2.default)(rest, 'data.is_agent') || undefined;
    var is_active = !!rest.data ? isAgent : true;

    var routes = ['property/edit', 'manage_properties', 'home_details', 'foreign_property/edit'];
    var shouldLoad = routes.every(function (route) {return !pathname.includes(route);});

    if (shouldLoad && accessToken) {
      var promises = [
      !getState().manageProperties.data && dispatch((0, _manageProperties.loadUserProperties)({ token: accessToken, data: { is_active: is_active } })),
      dispatch((0, _manageProperties.setCurrentPaginationStep)(0))];


      return Promise.all(promises);
    }
    return null;
  } }];exports.default =


(0, _ramda.compose)(
(0, _reduxConnect.asyncConnect)(asyncData),
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(
App);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/App/App.js
// module id = 3013
// module chunks = 0